export class TelemedicineExternalSearchRequest {
    public url: string;
    public token: string;
    public idHealthUnit: number;
    public searchKey: string;

}